import { render, staticRenderFns } from "./InventoryAgingReport.vue?vue&type=template&id=6f7db4c8&"
import script from "./InventoryAgingReport.vue?vue&type=script&lang=js&"
export * from "./InventoryAgingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports